<template>
    <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-4 text-center text-md-left mb-4 mb-md-0">
                    <a target="_blank" :href="utgLink">
                        <img src="../assets/images/logo-white.png">
                    </a>
                </div>
                <div class="col-12 col-md-4 d-flex align-items-center justify-content-center mb-4 mb-md-0">
                    <div class="row d-flex align-items-center">
                        <div class="col-2">
                            <i class="icon-headset icon-2x text-light"></i>
                        </div>
                        <div class="col-10">
                            <ul class="p-0 m-0">
                                <li v-for="phone in phones">
                                    <a :href="'tel:' + phone">{{ phone }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 d-flex justify-content-center justify-content-md-end align-items-center mb-4 mb-md-0">
                    <div class="text-md-right">
                        <a class="d-block text-light font-weight-bold mb-2" :href="'mailto:' + mail">
                            {{ mail }}
                        </a>
                        <a class="d-block text-light font-weight-bold mb-2" target="_blank" :href="fbLink">
                            <i class="fab fa-facebook fa-lg"></i>
                            Ми у Facebook
                        </a>
                        <div class="font-weight-lighter text-light">
                            <small class="copyright">© УТГ {{ year }}. Усi права захищенi</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        data() {
            return {
                year: (new Date()).getFullYear(),
                fbLink: "https://www.facebook.com/Smart-Misto-625945008039045/",
                utgLink: "https://utelecom.com.ua",
                mail: "sales@utelecom.com.ua",
                phones: [
                    "+38 (044) 353-94-50",
                    "+38 (068) 982-49-60",
                ]
            }
        }
    }
</script>

<style lang="less" scoped>

    .footer {
        position: relative;
        margin-top: calc((var(--top-bar-height) + 10px) * -1);
        padding: 2rem 1rem;
        width: 100%;
        background: var(--footer-bg-color);

        img {
            height: 100px;

            @media (max-width: 600px) {
                height: 50px;
            }
        }

        ul {
            list-style: none;

            li a {
                color: #fff;
                font-weight: 500;
                text-decoration: none;
            }
        }
    }

</style>